import { regex } from "react-admin";
const regexQuery = new RegExp(
  "^((http|https)://)[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$"
);
export const validateUrl = regex(
  regexQuery,
  "Must be a valid url - try starting with https://"
);
